import React from "react";

const PowerBIFrame = ({ url, title }) => {
  return (
    <iframe
      title={title}
      src={url}
      className="dm-powerbi-frame"
      frameBorder="0"
      allowFullScreen
    />
  );
};

export default PowerBIFrame;
